let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("984Ti")).then(() => parcelRequire('jvvYC'));